import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import HowDidYouObtainLecBrochurePage from './how-did-you-obtain-lec-brochures'

const howDidYouObtainLecBrochuresRoutes: Route[] = [
  {
    path: Paths.HOW_DID_YOU_OBTAIN_LEC_BROCHURE_LIST_PAGE,
    element: <HowDidYouObtainLecBrochurePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default howDidYouObtainLecBrochuresRoutes
